// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_hKOiM","formSelect":"index_formSelect_T-P8O","active":"index_active_Na9VA"};